export const SpinnerTheme = {
    Spinner: {
        sizes: {
            '3xs': 5,
            '2xs': 10,
            'xs': 20,
            'sm': 36,
            'md': 48,
            'lg': 64,
            'xl': 72,
            '2xl': 144,
        }
      },
}